module.exports = __webpack_public_path__ + "img/MLGI.29bb9dfc.jpg";